'use client';

import { useEffect } from 'react';

/**
 * Hook for handling left/right swipe gestures
 * @param {Object} options
 * @param {Function} options.onSwipeLeft - Callback when swiping left (next)
 * @param {Function} options.onSwipeRight - Callback when swiping right (previous)
 * @param {boolean} [options.disabled=false] - Whether swipe navigation is disabled
 * @param {number} [options.minSwipeDistance=80] - Minimum swipe distance in pixels to trigger
 */
export default function useSwipeNavigation({ onSwipeLeft, onSwipeRight, disabled = false, minSwipeDistance = 80 }) {
  useEffect(() => {
    let touchStartX = 0;
    let touchStartY = 0;

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchEnd = (e) => {
      if (disabled) return;

      const touchEndX = e.changedTouches[0].clientX;
      const touchEndY = e.changedTouches[0].clientY;
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;

      // Only trigger if horizontal swipe is greater than vertical (not scrolling)
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
        if (deltaX > 0) {
          onSwipeRight?.();
        } else {
          onSwipeLeft?.();
        }
      }
    };

    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [onSwipeLeft, onSwipeRight, disabled, minSwipeDistance]);
}
